import { Injectable } from '@angular/core';
import { AbreCuentasService } from '../abre-cuentas/abre-cuentas.service';
import { BitacoraService } from '../bitacora/bitacora.service';
import { CaptureService } from '../capture/capture.service';
import { CopyService } from '../copies/copy.service';
import { NavigationService } from '../navigation/navigation-onboarding.service';
import { ProductLoaderService } from '../product-loader/product-loader.service';

@Injectable({
  providedIn: 'root',
})
export class IncomesService {

  constructor(
    private productLoaderService: ProductLoaderService,
    public copyService: CopyService,
    private captureService: CaptureService,
    private navigationService: NavigationService,
    private abreCuentasService: AbreCuentasService,
    private bitacoraService: BitacoraService,
  ) { }

  async callIncomes() {
    // this.productLoaderService.show(this.copyService.copies.show_load_pco);
    return await this.captureService.performIncomes().then(async (res: any) => {
      if (res !== '200') {
        this.navigationService.navigateToGeneralInformation('500');
        return;
      }
      // this.productLoaderService.hide();
      return '200';
    }).catch(() => this.navigationService.navigateToGeneralInformation('500'));
  }
}
